import SendRoundedIcon from '@material-ui/icons/SendRounded';
import styled from "styled-components";


const Container = styled.div`
    height: 50vh;
    background-color: #ececec;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
`

const NewsTitle = styled.h1`
    font-size: 70px;
    margin-bottom: 20px;
`
const Description = styled.div`
    font-size: 24px;
    font-weight: 300;
    margin-bottom: 20px;
`
const InputContainer = styled.div`
    width: 35%;
    height: 40px;
    background-color: white;
    display: flex;
    justify-content: space-between;
    border: 1px solid lightgray;
`

const Input = styled.input`
    border: none;
    flex: 10;
    padding-left: 20px;
`
const Button = styled.button`
    flex: 1.5;
    border: none;
    background-color: #b7dffa;
`



const Newsletter = () => {
    return (
        <Container>
            <NewsTitle > Newsletter </NewsTitle>
            <Description > Get promos and information </Description>
            <InputContainer >
                <Input placeholder="Your email" />
                <Button > <SendRoundedIcon /> </Button>
            </InputContainer>
        </Container>
    )
}

export default Newsletter
